import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Whatsapp from '../assets/images/whatsapp.png';
import CommerceManager from '../assets/images/commerce_management.png';
import GoogleMyBusiness from '../assets/images/google_my_business.png';
import { useNavigate } from 'react-router-dom';
import Swalaleart from '../whatsapp/function/swalaleart';

const Clientarea = () => {
  const navigate = useNavigate();

  const items = [
    { name: "WhatsApp", icon: Whatsapp, link: "whatsapp/dashboard" },
    { name: "Google My Business", icon: GoogleMyBusiness, link: "gmb/dashboard" },
    { name: "Commerce Manager", icon: CommerceManager, link: null },
  ];

  const handleClick = (link) => {
    if (link) {
      navigate(link);
    } else {
        Swalaleart({
            title: 'Coming Soon!',
            text: 'This feature is under development.',
            icon: 'info',
            confirmColor: '#1fee5b',
        });
    }
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center vh-100"
      style={{
        backgroundImage: "url('https://source.unsplash.com/1600x900/?technology,blur')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Overlay for dark blur effect */}
      <div
        className="position-absolute w-100 h-100"
        style={{
          backdropFilter: "blur(10px)",
          backgroundColor: "rgba(0,0,0,0.4)",
          zIndex: 1,
        }}
      ></div>

      <div className="container text-center position-relative" style={{ zIndex: 2 }}>
        <div className="row g-4 justify-content-center">
          {items.map((item, idx) => (
            <div 
              key={idx} 
              className="col-6 col-md-3"
              style={{ cursor: "pointer" }}
              onClick={() => handleClick(item.link)}
            >
              <div
                className="p-4 bg-light rounded shadow-sm d-flex flex-column justify-content-center align-items-center"
                style={{ minHeight: "200px" }}
              >
                <img 
                  src={item.icon} 
                  alt={item.name} 
                  style={{ width: "80px", height: "80px", objectFit: "contain" }} 
                />
                <h5 className="mt-3">{item.name}</h5>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Clientarea;